var React = require('react');

function IconB3Close (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"opacity":"0.8","fill":"#FFFFFF","cx":"16","cy":"15.999","r":"16","key":0}),React.createElement("path",{"fill":"#3C3C3B","d":"M16.69,16l4.974-4.974c0.2-0.2,0.2-0.523,0-0.725c-0.201-0.199-0.524-0.199-0.723,0l-4.944,4.944\n\t\tl-4.943-4.942c-0.199-0.2-0.522-0.2-0.724,0c-0.198,0.2-0.198,0.523,0,0.723l4.975,4.975l-4.975,4.974\n\t\tc-0.198,0.199-0.198,0.522,0,0.723c0.1,0.1,0.232,0.151,0.362,0.151c0.132,0,0.262-0.051,0.362-0.151l4.943-4.943l4.944,4.942\n\t\tc0.099,0.101,0.229,0.151,0.361,0.151c0.13,0,0.26-0.05,0.362-0.151c0.199-0.2,0.199-0.523,0-0.724L16.69,16z","key":1})]));
}

IconB3Close.displayName = "IconB3Close";

IconB3Close.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = IconB3Close;

IconB3Close.default = IconB3Close;
